// Client for the /auth/web/* endpoints.
//
// Deliberately NOT part of IpcContract: these never reach a Core, so entries in
// CHANNEL_TOPICS / READ_ONLY would be meaningless noise in maps whose whole value
// is that every entry was a decision.

const CSRF_COOKIE = 'tnd_web_csrf'
const CSRF_HEADER = 'x-tendally-csrf'
/** Forces a CORS preflight the server never grants, so a cross-site form cannot post. */
const CLIENT_HEADER = 'x-tendally-web'

function readCookie(name: string): string | null {
  const prefix = `${name}=`
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) return decodeURIComponent(part.slice(prefix.length))
  }
  return null
}

export interface WebError {
  code: string
  message: string
  details?: unknown
}

export type WebResult<T> = { ok: true; data: T } | { ok: false; error: WebError }

export async function webAuth<T>(op: string, body: unknown = {}): Promise<WebResult<T>> {
  let res: Response
  try {
    res = await fetch(`/auth/web/${op}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        [CLIENT_HEADER]: '1',
        // Double-submit: echo the readable cookie back in a header a cross-origin
        // form could never set.
        [CSRF_HEADER]: readCookie(CSRF_COOKIE) ?? ''
      },
      body: JSON.stringify(body)
    })
  } catch {
    return { ok: false, error: { code: 'NETWORK', message: 'Could not reach the server' } }
  }
  if (!res.ok) {
    return { ok: false, error: { code: 'NETWORK', message: `Network error (${res.status})` } }
  }
  return (await res.json()) as WebResult<T>
}
